// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketDefault__container___2UIMz","button":"MarketDefault__button___XHLqe","vs":"MarketDefault__vs___TdLht","has-three-odds":"MarketDefault__has-three-odds___2z_gC"};